module.exports = __webpack_public_path__ + "static/media/social8.a3a57c17.png";